import { gql } from '@apollo/client'

export const CREATE_SERVICE = gql`
  mutation CreateService($input: createServiceInput!) {
    createService(input: $input)
  }
`

export const CREATE_SERVICE_ITINERARIES_SCHEDULE = gql`
  mutation CreateServiceItinerariesSchedule($input: CreateRouteServiceItinerariesScheduleInput!) {
    createRouteServiceItinerariesSchedule(input: $input)
  }
`

export const EDIT_ITINERARIES_SCHEDULE = gql`
  mutation EditItinerariesSchedule($input: ChangeRouteServiceItinerariesScheduleInput!) {
    changeRouteServiceItinerariesSchedule(input: $input)
  }
`

export const CREATE_VEHICLES_SCHEDULE = gql`
  mutation CreateVehiclesSchedule($input: CreateRouteServiceVehiclesScheduleInput!) {
    createRouteServiceVehiclesSchedule(input: $input)
  }
`

export const DELETE_VEHICLES_SCHEDULE = gql`
  mutation DeleteVehiclesSchedule($input: DeleteRouteServiceVehiclesScheduleInput!) {
    deleteRouteServiceVehiclesSchedule(input: $input)
  }
`

export const EDIT_VEHICLES_SCHEDULE = gql`
  mutation EditVehiclesSchedule($input: ChangeRouteServiceVehiclesScheduleInput!) {
    changeRouteServiceVehiclesSchedule(input: $input)
  }
`

export const EDIT_SERVICE = gql`
  mutation EditService($service: UpdateServiceInput!) {
    updateService(input: $service)
  }
`

export const ARCHIVE_ITINERARY_SCHEDULE = gql`
  mutation ArchiveItinerarySchedule($input: ArchiveRouteServiceItineraryScheduleInput!) {
    archiveRouteServiceItinerarySchedule(input: $input)
  }
`

export const SCHEDULE_ROUTE_SERVICE_TRIPS = gql`
  mutation ScheduleRouteServiceTrips($input: ScheduleRouteServiceTripsInput!) {
    scheduleRouteServiceTrips(input: $input)
  }
`

export const CREATE_TRIP = gql`
  mutation CreateRouteServiceSingleTrip($input: CreateRouteServiceSingleTripInput!) {
    createRouteServiceSingleTrip(input: $input)
  }
`

export const ADD_ROUTE_SERVICE_PEAKS = gql`
  mutation AddRouteServicePeaks($input: AddRouteServicePeaksInput!) {
    addRouteServicePeaks(input: $input)
  }
`
